<div class="spin-loader">
  <mat-icon class="spin-loader__loop" *ngIf="isLoading">loop</mat-icon>
  <mat-icon class="spin-loader__check" *ngIf="!isLoading && isLoaderFinished">check</mat-icon>
</div>
